import { StickySection, defineSection } from '@decify/cell-shopify/client';
import './banner.scss';
export const BannerName = 'Banner';
export const BannerTagName = 'cell-section-banner';
class Banner extends StickySection {
    constructor() {
        super(BannerName);
    }
    componentDidMount() {
        super.componentDidMount();
    }
}
defineSection(BannerTagName, Banner);
